module.exports = __webpack_public_path__ + "img/Logo-mtg.513b9884.png";